import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Divider, HStack, rem, SparklesSolid } from '@bonusly/design-system';

interface AiPromptNoteProps {
	onClickClear: VoidFunction;
}

export const AiPromptNote: FC<AiPromptNoteProps> = ({ onClickClear }) => {
	const { t } = useTranslation('feedback');

	return (
		<HStack color="text.softest" fontSize="sm" h={rem(18)} px={2} my={1}>
			<SparklesSolid size="sm" />
			<Box as="span">{t('feedback.request.ai_generated')}</Box>
			<Divider orientation="vertical" />
			<Box as="a" cursor="pointer" _hover={{ textDecor: 'underline' }} onClick={onClickClear}>
				{t('feedback.request.ai_clear')}
			</Box>
		</HStack>
	);
};
